import { Mail, MapPin, Phone } from "lucide-react";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { MaskLines, Reveal, editableLines } from "@/components/site/Motion";
import { EImg, T } from "@/context/ContentContext";
import { useContact } from "@/hooks/useContact";
import { IMG } from "@/data/site";

export function CallbackSection({ preset = {}, title = ["Dreaming of", "your next trip?"], k = "callback" }) {
  const c = useContact();
  return (
    <section className="bg-cream py-24 sm:py-32" data-testid="callback-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 space-y-8">
          <T k={`${k}.eyebrow`} as="p" className="eyebrow text-terra">Get in touch</T>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.03em] leading-[0.95]">
            <MaskLines inView lines={editableLines(`${k}.title`, title)} delay={0} />
          </h2>
          <Reveal className="space-y-4 text-ink/80">
            <a href={`tel:+91${c.phone}`} className="flex items-center gap-3 hover:text-terra transition-colors" data-testid="callback-phone-link"><Phone className="h-4 w-4 text-terra" />{c.phoneDisplay}</a>
            <a href={`mailto:${c.email}`} className="flex items-center gap-3 hover:text-terra transition-colors" data-testid="callback-email-link"><Mail className="h-4 w-4 text-terra" />{c.email}</a>
            <p className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-1 shrink-0 text-terra" />{c.address}</p>
          </Reveal>
          <Reveal className="relative arch-sm overflow-hidden aspect-[16/10] max-w-md">
            <EImg place="bottom-4 right-4" k={`${k}.img`} src={IMG.groupHug} alt="Friends watching the sunset" loading="lazy" className="h-full w-full object-cover" />
          </Reveal>
        </div>
        <Reveal className="lg:col-span-7 bg-paper rounded-[32px] p-6 sm:p-10 shadow-[0_30px_80px_-40px_rgba(21,17,14,0.35)]">
          <T k={`${k}.form-title`} as="p" className="font-serif italic text-3xl mb-6">Allow us to call you back.</T>
          <EnquiryForm preset={preset} idPrefix="callback" />
        </Reveal>
      </div>
    </section>
  );
}
